import PressReleasesSection from './PressReleasesSection';

export default PressReleasesSection;
